import React from 'react'

const FrenchFlag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_11193_6447)'>
      <path
        d='M21.6128 4.85107H6.32031V20.3686H21.6128C23.0363 20.3686 24.1891 18.9878 24.1891 17.2872V7.93282C24.1891 6.23182 23.0363 4.85182 21.6128 4.85182'
        fill='#E6E7E8'
      />
      <path
        d='M8.15866 4.85109H2.88616C1.46491 4.85109 0.311035 6.23109 0.311035 7.93247V10.0231V15.1955V17.2865C0.311035 18.9871 1.46379 20.3678 2.88804 20.3678H8.15679V4.85034'
        fill='#1B75BB'
      />
      <path
        d='M2.85874 4.85107C1.43486 4.85107 0.281738 6.23107 0.281738 7.93245V10.0231V15.1962V17.2876C0.281738 18.9886 1.43486 20.3689 2.85874 20.3689H7.42211V15.1954V10.0223V4.85107H2.85874Z'
        fill='#176496'
      />
      <path
        d='M21.6437 4.85107H16.375V20.3686H21.6437C23.0672 20.3686 24.22 18.9886 24.22 17.2872V15.1969V10.0238V7.9332C24.22 6.23182 23.0672 4.85182 21.6437 4.85182'
        fill='#EC1C24'
      />
    </g>
    <defs>
      <clipPath id='clip0_11193_6447'>
        <rect width='24' height='24' fill='white' transform='translate(0.25)' />
      </clipPath>
    </defs>
  </svg>
)

export default FrenchFlag
